import { motion, AnimatePresence } from "framer-motion"
import React, { ReactNode } from "react"

export type AnimateAppearanceProps = {
  show: boolean
  children: ReactNode
}

export const AnimateAppearance = (props: AnimateAppearanceProps) => {
  const { show, children } = props

  return (
    <AnimatePresence>
      {show && (
        <Root
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ type: "linear", duration: 0.3 }}
        >
          {children}
        </Root>
      )}
    </AnimatePresence>
  )
}

const Root = motion.div
